import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

import { GeolocationClientConfig } from '@frontend/geo-coordinator/client-models';
import { CasinoGeolocationClientConfig } from '@frontend/geo-coordinator/client-stub';
import { OnAppInit } from '@frontend/vanilla/core';

@Injectable({ providedIn: 'root' })
export class CoordinatorBootstrapperService implements OnAppInit {
    private readonly geolocationClientConfig: GeolocationClientConfig = inject(CasinoGeolocationClientConfig);
    private readonly documentRef = inject(DOCUMENT);

    onAppInit(): void {
        if (this.geolocationClientConfig && this.geolocationClientConfig.isEnabled) {
            this.geolocationClientConfig.assetsPath.forEach((path: string) => {
                const scriptElement = this.documentRef.createElement('script');
                scriptElement.src = path;
                this.documentRef.body.appendChild(scriptElement);
            });
        }
    }
}
